import React, { useState, useEffect, useRef } from 'react';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import PartnerHeader from '../school/PartnerHeader';
import { useAuth } from '../../auth/Auth';
import PartnerUnverifiedModal from '../school/PartnerUnverifiedModal';
import StandardChallenge from './StandardChallenge';
import SpecialChallenge from './SpecialChallenge';
import Event from './Event';
import { agoraViewModel } from '../../common/agora.view.model';
import { PARTNER_CHALLENGES } from '../../../constants/routes.constants';

const AddPartnerChallenge = () => {
  const { partner } = useAuth();
  const history = useHistory();
  const expertId = history.location.state?.expertId ? history.location.state.expertId : partner?.user_type === 'camp master' ? partner.id : '';
  const agoraGroupId = history.location.state?.expert_agora_group_id ? history.location.state.expert_agora_group_id : '';
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [challengeType, setChallengeType] = useState("");
  const [appToken, setAppToken] = useState(null);

  const getAppToken = async () => {
    let res = await agoraViewModel.getAppToken()
    setAppToken(res.data.app_token)
  }

  const pageRedirect = () => {
    history.goBack();
  }

  const challengeTypes = [
    { value: 'standard', label: 'A challenge' },
    { value: 'special', label: 'A special challenge (Challenge plus live event)' },
    { value: 'event', label: 'A live event' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      maxWidth: 520,
      margin: 'auto',
      color: '#321b6d',
      fontWeight: '400',
      cursor: 'pointer'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  useEffect(() => {
    setIsLoading(false)
    getAppToken()
  }, [])

  useEffect(() => {
    if(partner) {
      if(partner?.user_type === 'partner' && !expertId) history.push(PARTNER_CHALLENGES)
    }
  }, [partner])

  return (
    <div className='partner-wrapper-main'>
      <PartnerHeader />
      <PartnerUnverifiedModal showModal={showModal} setShowModal={setShowModal} />
      <div className='add-more-branches partner_add_challenges'>
        <span className="back-btn" onClick={pageRedirect}><HiOutlineChevronLeft /></span>
        <div className='partner-challenge'>
          <p>I want to add:</p>
          <Select
            options={challengeTypes}
            styles={customStyles}
            theme={(theme) => ({
              ...theme,
              borderRadius: '6px',
              colors: {
                ...theme.colors,
                primary: '#80e4e1',
              },
            })}
            onChange={(e) => (setChallengeType(e.value))}
          />
        </div>
        {!isLoading ?
          challengeType === "standard" ? <StandardChallenge expertId={expertId} appToken={appToken} agoraGroupId={agoraGroupId} /> :
            challengeType === "special" ? <SpecialChallenge expertId={expertId} appToken={appToken} agoraGroupId={agoraGroupId} /> : 
            challengeType === "event" ? <Event expertId={expertId} appToken={appToken} agoraGroupId={agoraGroupId} /> : ""
          : ""}
      </div>
    </div>
  )
}

export default AddPartnerChallenge;